import { render, staticRenderFns } from "./commentManagement.vue?vue&type=template&id=4051b0fa&"
import script from "./commentManagement.vue?vue&type=script&lang=js&"
export * from "./commentManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports